import { render, staticRenderFns } from "./Button-Secondary.vue?vue&type=template&id=51fe8729&scoped=true&"
import script from "./Button-Secondary.vue?vue&type=script&lang=js&"
export * from "./Button-Secondary.vue?vue&type=script&lang=js&"
import style0 from "./Button-Secondary.vue?vue&type=style&index=0&id=51fe8729&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe8729",
  null
  
)

export default component.exports